import { useState } from 'react';

export default function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    const form = e.currentTarget;
    const formData = new FormData(form);

    try {
      const response = await fetch('https://readdy.ai/api/form/d4rlrlonlksjl5n0476g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(formData as any).toString(),
      });

      if (response.ok) {
        setSubmitStatus('success');
        form.reset();
        // Chuyển hướng đến trang thank you sau 1 giây
        setTimeout(() => {
          window.location.href = 'https://thankyou.phuotmy.com/';
        }, 1000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-6">
            Đăng Ký Nhận Báo Giá
          </h2>
          <p className="text-xl md:text-2xl text-gray-900 max-w-3xl mx-auto font-semibold">
            Bạn là công ty du lịch – phòng vé – du học – tổ chức đoàn đến Mỹ?<br />
            Hãy đăng ký để được báo giá chính xác theo lịch trình.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8">
          {/* Main Form - Takes 2 columns */}
          <div className="lg:col-span-2">
            <form
              id="contact-registration-form"
              data-readdy-form
              onSubmit={handleSubmit}
              className="bg-white rounded-2xl shadow-xl p-8 md:p-10"
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Họ tên <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    name="fullName"
                    required
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                    placeholder="Nhập họ tên của bạn"
                  />
                </div>

                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Công ty / Đơn vị <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    name="company"
                    required
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                    placeholder="Tên công ty hoặc đơn vị"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Số điện thoại / Zalo <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    required
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                    placeholder="Số điện thoại liên hệ"
                  />
                </div>

                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Email <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    required
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                    placeholder="Email của bạn"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Số khách <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="number"
                    name="passengers"
                    required
                    min="1"
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                    placeholder="Số lượng khách"
                  />
                </div>

                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Loại xe cần thuê <span className="text-red-600">*</span>
                  </label>
                  <div className="relative">
                    <select
                      name="vehicleType"
                      required
                      className="w-full px-4 py-4 pr-10 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all appearance-none cursor-pointer text-base font-medium"
                    >
                      <option value="">Chọn loại xe</option>
                      <option value="5-7-15">Xe 5–7–15 chỗ</option>
                      <option value="15-25">Xe 15–25 chỗ</option>
                      <option value="36-56">Xe 36–56 chỗ</option>
                    </select>
                    <i className="ri-arrow-down-s-line absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-600 pointer-events-none text-xl"></i>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Tuyến dự kiến
                  </label>
                  <input
                    type="text"
                    name="route"
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                    placeholder="VD: LA - Vegas - Grand Canyon"
                  />
                </div>

                <div>
                  <label className="block text-gray-900 font-bold mb-2 text-lg">
                    Ngày khởi hành
                  </label>
                  <input
                    type="date"
                    name="departureDate"
                    className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all text-base font-medium"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label className="block text-gray-900 font-bold mb-2 text-lg">
                  Yêu cầu riêng
                </label>
                <textarea
                  name="requirements"
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-4 border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 focus:border-transparent outline-none transition-all resize-none text-base font-medium"
                  placeholder="Mô tả yêu cầu đặc biệt của bạn (tối đa 500 ký tự)"
                ></textarea>
                <p className="text-base text-gray-700 mt-2 font-semibold">
                  {0}/500 ký tự
                </p>
              </div>

              {submitStatus === 'success' && (
                <div className="mb-6 p-5 bg-green-50 border-2 border-green-300 rounded-lg">
                  <p className="text-green-900 flex items-center text-lg font-bold">
                    <i className="ri-checkbox-circle-fill text-2xl mr-3"></i>
                    Gửi thành công! Đang chuyển hướng...
                  </p>
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="mb-6 p-5 bg-red-50 border-2 border-red-300 rounded-lg">
                  <p className="text-red-900 flex items-center text-lg font-bold">
                    <i className="ri-error-warning-fill text-2xl mr-3"></i>
                    Có lỗi xảy ra. Vui lòng thử lại sau.
                  </p>
                </div>
              )}

              <button
                type="submit"
                disabled={isSubmitting}
                className="whitespace-nowrap w-full bg-red-600 hover:bg-red-700 disabled:bg-gray-400 text-white px-8 py-5 rounded-lg text-xl font-extrabold transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <i className="ri-loader-4-line animate-spin mr-2 text-2xl"></i>
                    Đang gửi...
                  </>
                ) : (
                  'Nhận báo giá chi tiết'
                )}
              </button>
            </form>
          </div>

          {/* Sidebar - Takes 1 column */}
          <div className="space-y-6">
            <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
              <h3 className="text-2xl font-extrabold text-gray-900 mb-4">
                Trao đổi nhanh qua Zalo
              </h3>
              <div className="bg-gray-100 p-6 rounded-xl mb-4">
                <img
                  src="https://static.readdy.ai/image/59f6a965c15708ede5dfacf8eca2f025/86a6a551f218bbee40e01ece34524d44.jpeg"
                  alt="Zalo QR Code"
                  className="w-full h-auto mx-auto rounded-lg"
                />
              </div>
              <p className="text-gray-800 text-lg font-semibold">
                Quét mã QR để tham gia nhóm Zalo, nhận tư vấn trực tiếp và cập nhật ưu đãi mới nhất
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-900 to-blue-800 rounded-2xl shadow-xl p-8 text-white">
              <h3 className="text-2xl font-extrabold mb-6" style={{ textShadow: '0 2px 6px rgba(0,0,0,0.5)' }}>
                Liên hệ trực tiếp
              </h3>
              <div className="space-y-4">
                <div className="flex items-start">
                  <i className="ri-phone-fill text-3xl mr-3 mt-1"></i>
                  <div>
                    <p className="font-extrabold text-lg" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>Hotline</p>
                    <p className="text-blue-100 text-lg font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>+1 714 552 1068</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-mail-fill text-3xl mr-3 mt-1"></i>
                  <div>
                    <p className="font-extrabold text-lg" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>Email</p>
                    <p className="text-blue-100 text-lg font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>americadiscoverytravel@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-time-fill text-3xl mr-3 mt-1"></i>
                  <div>
                    <p className="font-extrabold text-lg" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>Giờ làm việc</p>
                    <p className="text-blue-100 text-lg font-bold" style={{ textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>24/7 - Hỗ trợ mọi lúc</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
